"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coordinatesListSort = exports.timeFormat = exports.dateFormat = exports.getFirstImageUrl = exports.capitalize = exports.languageFlagImage = exports.serverMediaFile = exports.translation = void 0;
var parameters_1 = __importDefault(require("@/config/parameters"));
var dayjs_1 = __importDefault(require("dayjs"));
function translation(translations, languageCodeSelected, property) {
    for (var i = 0; i < translations.length; i++) {
        if (translations[i].language.iso_639_1_code === languageCodeSelected) {
            if (translations[i][property] === undefined) {
                continue;
            }
            return translations[i][property];
        }
    }
    throw new Error("Translation not found: " + languageCodeSelected);
}
exports.translation = translation;
function serverMediaFile(file) {
    // eslint-disable-next-line no-prototype-builtins
    if (!parameters_1.default.cdn.directories.hasOwnProperty(file.mimetype)) {
        throw new Error('Unknown type file');
    }
    var directory = parameters_1.default.cdn.directories[file.mimetype];
    return parameters_1.default.cdn.host + "/" + directory + "/" + file.filename;
}
exports.serverMediaFile = serverMediaFile;
function languageFlagImage(languageIsoCode) {
    return parameters_1.default.cdn.host + "/" + parameters_1.default.cdn.languageFlagsDirectory + "/" + languageIsoCode + ".png";
}
exports.languageFlagImage = languageFlagImage;
function capitalize(value) {
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
}
exports.capitalize = capitalize;
function getFirstImageUrl(images, customDefaultImage) {
    if (customDefaultImage === void 0) { customDefaultImage = null; }
    if (images.length) {
        return serverMediaFile(images[0].file_uploaded);
    }
    if (customDefaultImage !== null) {
        return customDefaultImage;
    }
    return require('@/assets/images/default-image-poi.jpg');
}
exports.getFirstImageUrl = getFirstImageUrl;
function dateFormat(date, format) {
    if (date) {
        return dayjs_1.default(date).format(format);
    }
    return null;
}
exports.dateFormat = dateFormat;
function timeFormat(time) {
    if (time) {
        return dayjs_1.default(time, 'HH:mm:ss').format('HH:mm');
    }
    return null;
}
exports.timeFormat = timeFormat;
function coordinatesListSort(coordinatesList) {
    return coordinatesList.map(function (coordinates) { return [coordinates[1], coordinates[0]]; });
}
exports.coordinatesListSort = coordinatesListSort;
